<script lang="ts">
  import { navigating } from "$app/stores";
  import { page } from "$app/stores";

  import { afterUpdate, onMount } from "svelte";

  // TODO(erikbern): this seems a bit janky: let me know if there's a better way:
  import * as _examples from "$lib/../../generated/examples.json";
  import TextSkeleton from "$lib/ui/system/TextSkeleton.svelte";
  import ExampleLink from "./ExampleLink.svelte";

  interface Example {
    stem: string;
    repo_filename: string;
    cli_args: string[];
  }

  const examples: Example[] = (_examples as any).default;

  export let activeHeadings = new Set<string>();

  let element: HTMLDivElement;
  let observer: IntersectionObserver;

  onMount(() => {
    function onIntersect(entries: IntersectionObserverEntry[]) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          activeHeadings.add(entry.target.id);
        } else {
          activeHeadings.delete(entry.target.id);
        }
      }
      activeHeadings = activeHeadings;
    }

    observer = new IntersectionObserver(onIntersect, { threshold: 0.8 });
    return () => observer.disconnect();
  });

  afterUpdate(async () => {
    element.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((heading) => {
      if (heading.id) {
        observer.observe(heading);
      }
    });
  });

  // If this is an example, use the right repo filename
  const items: string[] = $page.url.pathname.split("/");
  const item: string = items[items.length - 1];
  const itemSection: string | undefined =
    items.length > 1 ? items[items.length - 2] : undefined;
  const example: Example | undefined =
    itemSection === "examples"
      ? examples.find((ex) => ex.stem == item)
      : undefined;
  export const cliArgs =
    itemSection === "examples" ? example?.cli_args : undefined;
</script>

<div class="text-c-gray-80" bind:this={element}>
  {#if $navigating && $navigating.to?.url?.pathname?.startsWith("/docs")}
    <TextSkeleton />
  {:else}
    {#if example?.repo_filename}
      <ExampleLink scriptPath={example?.repo_filename} />
    {/if}
    <slot />
  {/if}
</div>
